import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { EventTypes } from 'src/app/core/constants/event-types';
import { Validator } from 'src/app/core/constants/validators';
import { ConsoleService } from 'src/app/core/services/console.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { AggregatorsService } from '../../../../core/api/services/aggregators.service';
import { ModalTitleComponent } from '../../../../shared/global/modal-title/modal-title.component';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';

@Component({
  selector: 'app-user-mobile',
  templateUrl: './user-mobile.component.html',
  imports: [BaseFormModule, ModalTitleComponent],
})
export class UserMobileComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  mobile = '';
  //#endregion

  constructor(
    protected currentService: AggregatorsService,
    private dialogRef: MatDialogRef<UserMobileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      mobile: new FormControl('', Validator.mobile),
    });
  }

  onClose() {
    this.dialogRef.close({ isSucceed: false, mobile: '' });
  }

  onSuccess() {
    this.dialogRef.close({ isSucceed: true, mobile: this.mobile });
    this.unSubs();
  }

  onSubmit() {
    try {
      if (this.loading) return;
      if (!this.isValidForm(this.form, this.tagName)) return;

      try {
        this.onSuccess();
      } catch (error) {
        ConsoleService.error('error', error);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.dashboard);
    }
  }
}
